var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.dataLoaded,
          expression: "dataLoaded"
        }
      ],
      staticClass: "user-container"
    },
    [
      _c("slider", {
        ref: "loginSlider",
        attrs: {
          title: "ACCOUNT SIGN IN",
          "can-close": _vm.allowLoginSliderClose
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var hide = ref.hide
              return _c("login", {
                ref: "login",
                attrs: {
                  hide: hide,
                  "show-signup-success": _vm.showSignupSuccess,
                  "reload-on-login": _vm.reloadOnLogin,
                  inPathDD: _vm.inPathDD
                }
              })
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("div", {
        ref: "background",
        staticClass: "user-background pointer",
        class: { "logged-in": _vm.member.isLoggedIn },
        on: { click: _vm.handleUserClick }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.member.isLoggedIn,
              expression: "member.isLoggedIn"
            }
          ],
          staticClass: "user-logged-in"
        },
        [
          _c("img", {
            ref: "avatar",
            staticClass: "user-avatar pointer",
            attrs: { src: _vm.member.image, alt: "" },
            on: {
              click: function($event) {
                _vm.logoutVisible = true
              }
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              ref: "logoutToggle",
              staticClass: "user-name",
              attrs: { role: "button", tabindex: "0" },
              on: {
                click: function($event) {
                  _vm.logoutVisible = true
                },
                keydown: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, " ")
                  ) {
                    return null
                  }
                  $event.stopPropagation()
                  $event.preventDefault()
                  _vm.logoutVisible = !_vm.logoutVisible
                }
              }
            },
            [
              _c("span", [_vm._v("Hi,")]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "first-name", attrs: { "data-cs-mask": "" } },
                [_vm._v(_vm._s(_vm.member.firstName))]
              ),
              _vm._v(" "),
              !_vm.isNDCLoggedIn
                ? _c("span", [
                    _vm._v("| " + _vm._s(_vm.member.currentMiles) + " mi.")
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "logout-container vertical center pointer",
              class: { visible: _vm.logoutVisible }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              !_vm.isNDCLoggedIn
                ? _c(
                    "f9button",
                    {
                      ref: "profileButton",
                      on: {
                        click: _vm.redirectToProfile,
                        keydown: [
                          function($event) {
                            if (
                              !("button" in $event) &&
                              _vm._k(
                                $event.keyCode,
                                "tab",
                                9,
                                $event.key,
                                "Tab"
                              )
                            ) {
                              return null
                            }
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.$refs.signOutButton.focus($event)
                          },
                          function($event) {
                            if (
                              !("button" in $event) &&
                              _vm._k(
                                $event.keyCode,
                                "esc",
                                27,
                                $event.key,
                                "Escape"
                              )
                            ) {
                              return null
                            }
                            $event.stopPropagation()
                            $event.preventDefault()
                            _vm.logoutVisible = false
                          }
                        ]
                      }
                    },
                    [_vm._v("VIEW PROFILE")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "f9button",
                {
                  ref: "signOutButton",
                  attrs: { gray: "" },
                  on: {
                    click: _vm.signOut,
                    keydown: [
                      function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                        ) {
                          return null
                        }
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.$refs.profileButton.focus($event)
                      },
                      function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "esc",
                            27,
                            $event.key,
                            "Escape"
                          )
                        ) {
                          return null
                        }
                        $event.stopPropagation()
                        $event.preventDefault()
                        ;(_vm.logoutVisible = false),
                          _vm.$refs.logoutToggle.focus()
                      }
                    ]
                  }
                },
                [_vm._v("LOG OUT")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "arrow" })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "logout-modal",
            class: { visible: _vm.logoutVisible },
            on: {
              click: function($event) {
                _vm.logoutVisible = false
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.member.isLoggedIn,
              expression: "!member.isLoggedIn"
            }
          ],
          staticClass: "pointer user-not-logged-in",
          attrs: { tabindex: "0" },
          on: {
            click: _vm.showLoginSlider,
            keydown: _vm.keyDownEnterOrSpaceToShowLoginSlider
          }
        },
        [_vm._v("\n      Hi, log in | sign up\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logout-text horizontal center around" }, [
      _c("span", { staticClass: "frontier" }, [_vm._v("FRONTIER Miles")]),
      _vm._v(" "),
      _c("span", { staticClass: "sm" }, [_vm._v("sm")]),
      _vm._v(" "),
      _c("span", { staticClass: "account" }, [_vm._v("ACCOUNT")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13610ef4", { render: render, staticRenderFns: staticRenderFns })
  }
}